import { IDonor } from "../../../../models";

export interface IChainStartItem {
    donor: IDonor,
    selected: boolean
}